// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__+lRPl","circle":"Loader_circle__DzuXv","spin":"Loader_spin__E4RJ0"};